import { render, staticRenderFns } from "./Kteacher.vue?vue&type=template&id=98e79a62&scoped=true"
import script from "./Kteacher.vue?vue&type=script&lang=js"
export * from "./Kteacher.vue?vue&type=script&lang=js"
import style0 from "./Kteacher.vue?vue&type=style&index=0&id=98e79a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e79a62",
  null
  
)

export default component.exports